import { render, staticRenderFns } from "./ProjectStats.vue?vue&type=template&id=59b2e5ef&"
import script from "./ProjectStats.vue?vue&type=script&lang=js&"
export * from "./ProjectStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59b2e5ef')) {
      api.createRecord('59b2e5ef', component.options)
    } else {
      api.reload('59b2e5ef', component.options)
    }
    module.hot.accept("./ProjectStats.vue?vue&type=template&id=59b2e5ef&", function () {
      api.rerender('59b2e5ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/client/ProjectStats.vue"
export default component.exports